import { baseQueryWithReauth } from './baseQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const usersApi = createApi({
    reducerPath: 'users',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Users'],
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: (body) => ({
                url: '/users',
                params: body
            }),
            providesTags: ['Users']
        }),
        editUser: builder.mutation({
            query: (body) => ({
                url: `/users`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Users'])
        }),
        getUserData: builder.query<any, void>({
            query: () => ({
                url: 'users/me'
            })
        }),
        submitTokenFcm: builder.mutation({
            query: (body) => ({
                url: `users/token-fcm`,
                body: body,
                method: 'PATCH'
            })
        }),
        getUserPorts: builder.query({
            query: () => ({
                url: 'users/puertos'
            }),
            transformResponse: (response: { data: { organizaciones: any } }) =>
                response?.data?.organizaciones
        }),
        changeUserPort: builder.mutation({
            query: (body) => ({
                url: 'users/me/puertos',
                body: body,
                method: 'PATCH'
            })
        })
    })
});

export const {
    useChangeUserPortMutation,
    useGetUserPortsQuery,
    useSubmitTokenFcmMutation,
    useGetUsersQuery,
    useEditUserMutation,
    useLazyGetUserDataQuery
} = usersApi;
